
import React from "react";
import ReactDOM from "react-dom";
import { navBarActions } from "@fpos/react-navigation";

import "./index.css";
import App from "./views/App";

import configureStore  from "./store";
import { initServices } from "./services";

import "@fpos/react-modal/lib/modal.css";
import "@fpos/react-controls/lib/fpos-react-controls.css";
import "@fpos/react-sass/global.scss";
import "@fpos/icon-streamline-30-filled/styles.css";
import "@fpos/icon-proxima-nova-alt/styles.css";


//need to wait until docs load so setting load before loading react
document.addEventListener("DOMContentLoaded", () => {
    console.log("SPA - index.js");
    var initialState = {};
    var userElement = document.getElementById("oauth-user");
    if (userElement) {
        var userString = userElement.getAttribute("data-mvcClaims");
        const mvc = JSON.parse(userString);

        initialState = {
            fposnav: {
                mvcClaims: mvc,
                isMvc: true
            }
        };
    }
    configureStore(initialState).then(store => {
        window.navigate = (path) => {
            store.dispatch(navBarActions.navigate(path));
        }
        initServices(store);
        ReactDOM.render(<App store={store} />, document.getElementById("root"));
    });
});


